module.exports = __webpack_public_path__ + "static/media/poop.92afeaaf.svg";